import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AccountTypeEnum } from '../enums';
import { JwtPayloadModel } from '../models';
import { UserAccountService } from '../services/user-account.service';

@Injectable({ providedIn: 'root' })
export class RoleGuard {
  readonly #userAccountService = inject(UserAccountService);
  readonly #platformId = inject(PLATFORM_ID);

  canActivate(
    next: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree | RedirectCommand {
    // During SSR, allow navigation - role check will happen on client
    if (!isPlatformBrowser(this.#platformId)) {
      return true;
    }

    const allowedRoles = next.data.roles as Array<AccountTypeEnum>;
    const userJWTDetails: JwtPayloadModel | undefined = this.#userAccountService.userJWTDetails();

    if (userJWTDetails) {
      if (userJWTDetails.iss === environment.API_URL && allowedRoles.includes(userJWTDetails.accountType)) {
        return true;
      }
    }

    return false;
  }
}
